.filterSection {
  text-transform: capitalize;
  margin: 20px 0;

  h4 {
    margin: 0;
  }
}
